import React from "react";
import { GlobalConfigContext } from './Config/GlobalConfigContext';
import { connect } from 'react-redux';

class Auth extends React.Component {
    static contextType = GlobalConfigContext;
    componentDidUpdate(prevProps) {
		//console.log(`Auth this.props:`, this.props);
		if(prevProps.isAuthenticated && !this.props.isAuthenticated){
            this.context.handleLogout(prevProps);
        }
        if(!prevProps.isAuthenticated && this.props.isAuthenticated){
            this.context.handleLoggedin({
                isAuthenticated: this.props.isAuthenticated,
                user: this.props.user,
                activeProperty: this.props.activeProperty,
                properties: this.props.properties,
                language: this.props.language,
                token: this.props.token,
                rules_token: this.props.rules_token,
                settings: this.props.settings,
            });
        }

    }
    render() {
        //console.log(`render context :`);
        return this.props.children;
    }
}

const mapStateToProps = state => {
	//console.log(`state:`, state.auth);
	return {
        isAuthenticated: state.auth.isAuthenticated,
        user: state.auth ? state.auth.user : null,
		activeProperty: state.auth.activeProperty,
		properties: state.auth.properties,
		language: state.auth.language,
		token: state.auth.token,
		rules_token: state.auth.rules_token,
		settings: state.auth.settings,
		//properties: propertiesSelectors.dataset(state, 'properties').get('data', List()),
		//isSetup: state.auth.isSetup,
		//isSetup: !Boolean((state.auth.activeProperty && state.auth.activeProperty.setup_completed) || false),
	};
};

export default connect(mapStateToProps)(Auth);